var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const trySerializeDate_1 = __importDefault(require("../trySerializeDate"));
function generateQueryString(data, includeTime) {
    if (!data) {
        return '';
    }
    return ('?' +
        getEncodedKeyValuePairs(data, includeTime)
            .map(kvp => kvp[0] + '=' + (kvp[1] === null ? '' : kvp[1]))
            .join('&'));
}
function getEncodedKeyValuePairs(data, includeTime, parentKeys) {
    const keys = Object.keys(data);
    if (!parentKeys) {
        parentKeys = [];
    }
    let keyValuePairs = [];
    keys.forEach(key => {
        if (data[key] === null || data[key] === undefined) {
            keyValuePairs.push([getEncodedKey(parentKeys, key), null]);
        }
        else if (data[key].constructor === Object) {
            const arrayParentKeys = parentKeys.slice(0);
            arrayParentKeys.push(key);
            keyValuePairs = keyValuePairs.concat(getEncodedKeyValuePairs(data[key], includeTime, arrayParentKeys));
        }
        else if (data[key].constructor === Array) {
            for (let i = 0; i < data[key].length; i++) {
                if (data[key][i] === null || data[key][i] === undefined) {
                    keyValuePairs.push([getEncodedKey(parentKeys, key, i), 'null']);
                }
                else if (data[key][i].constructor === Object) {
                    const arrayParentKeys = parentKeys.slice(0);
                    arrayParentKeys.push(key);
                    arrayParentKeys.push(i + '');
                    keyValuePairs = keyValuePairs.concat(getEncodedKeyValuePairs(data[key][i], includeTime, arrayParentKeys));
                }
                else {
                    keyValuePairs.push([getEncodedKey(parentKeys, key, i), getEncodedValue(data[key][i], includeTime)]);
                }
            }
        }
        else {
            keyValuePairs.push([getEncodedKey(parentKeys, key), getEncodedValue(data[key], includeTime)]);
        }
    });
    return keyValuePairs;
}
function getEncodedKey(parentKeys, key, arrayIndex) {
    let parentChain = '';
    if (parentKeys.length > 0) {
        parentChain = parentKeys.map((parentKey, i) => (i === 0 ? parentKey : '[' + parentKey + ']')).join('');
    }
    let newKey = parentChain + (parentChain ? '[' + key + ']' : key);
    if (arrayIndex !== undefined) {
        newKey += '[' + arrayIndex + ']';
    }
    return encodeURIComponent(newKey);
}
function getEncodedValue(value, includeTime) {
    let val = (0, trySerializeDate_1.default)(value, { includeTime });
    return encodeURIComponent(val);
}
exports.default = generateQueryString;
//# sourceMappingURL=generateQueryString.js.map